module.exports = __webpack_public_path__ + "img/gansu.59f47bc3.png";